import { useState } from "react";
import { Modal } from "react-bootstrap";





function ModalPopup(props) {

    function ButtonColor(){
        switch (props.modalType) {
            case 'W':
                return "btn-orange";
                break;
            case 'S':
                return "btn-green";
                break;
            default:
                return "btn-orange";
                break;

        }
    }

    function Button(){
        let btnText = "Ok";
        if(props.btnText !== undefined)
            btnText = props.btnText;

        if(props.callback !== undefined)
            return <button  className={"ue btn btn-blue"} onClick={props.callback}>{btnText}</button>
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.message}
            </Modal.Body>
            <Modal.Footer>
                <button  className={"ue btn "+ButtonColor()} onClick={props.onHide}>Chiudi</button>
            </Modal.Footer>
        </Modal>
    
    );
}

export default ModalPopup;